import React, { Suspense } from "react";

import { TodoEditDeadlinePopover } from "./TodoEditDeadlinePopover";

import { TodoEditPrioPopover } from "widgets/src/Todo/TodoPopovers/TodoEditPrioPopover";
import { TodoEditTagsPopover } from "widgets/src/Todo/TodoPopovers/TodoEditTagsPopover";
import { graphql, useFragment } from "react-relay";
import { TodoEditPopovers_todo$key } from "./__generated__/TodoEditPopovers_todo.graphql";

import { ToolbarFeature } from "widgets/src/Todo/TodoToolbar/TodoToolbarItem";
import { TodoEditTeamsPopover } from "./TodoEditTeamsPopover";

import { TodoEditAssigneesPopover } from "./TodoAssigneesPopover/TodoEditAssigneesPopover";
import { usePersistedEmployeeId } from "@/src/OS/Login/usePersistedEmployeeId";
import { TodoEditFeedbackPopover } from "./TodoEditFeedbackPopover";

export function TodoEditPopovers(props: {
  todo: TodoEditPopovers_todo$key;
  openFeature: ToolbarFeature | null | "SEND_FEEDBACK";
  dismissFeature: () => void;
  setStatus: (key: string, status: "saving" | "saved" | "error") => void;
}) {
  const { currentEmployeeId } = usePersistedEmployeeId();
  const todo = useFragment(
    graphql`
      fragment TodoEditPopovers_todo on Todo {
        ...TodoEditPrioPopover_todo
        ...TodoEditTagsPopover_todo
        ...TodoEditFeedbackPopover_todo
        ...TodoEditDeadlinePopover_todo
        id
        teams {
          id
        }
        assignedRoles {
          id
          role {
            id
            team {
              id
            }
          }
        }
      }
    `,
    props.todo
  );
  return (
    <Suspense fallback={null}>
      <TodoEditPrioPopover
        todo={todo}
        visible={props.openFeature === "PRIORITY"}
        onClose={props.dismissFeature}
        currentEmployeeId={currentEmployeeId ?? null}
      />
      <TodoEditTagsPopover
        todo={todo}
        visible={props.openFeature === "TAG"}
        onClose={props.dismissFeature}
        currentEmployeeId={currentEmployeeId ?? null}
      />
      <TodoEditDeadlinePopover
        todo={todo}
        onClose={props.dismissFeature}
        visible={props.openFeature === "DEADLINE"}
      />
      <TodoEditTeamsPopover
        todoId={todo.id}
        selectedTeamIds={todo.teams.map((t) => t.id)}
        assignedRoles={todo.assignedRoles}
        visible={props.openFeature === "TEAM"}
        onClose={props.dismissFeature}
        setStatus={props.setStatus}
      />
      <TodoEditAssigneesPopover
        todoId={todo.id}
        visible={props.openFeature === "ASSIGNEE"}
        onClose={props.dismissFeature}
        setStatus={props.setStatus}
      />
      <TodoEditFeedbackPopover
        todo={todo}
        key={todo.id}
        visible={props.openFeature === "SEND_FEEDBACK"}
        onClose={props.dismissFeature}
      />
    </Suspense>
  );
}
